import { useState } from "react";
import { storageService } from "@/shared/services/localStorage.service";

export const SPONSORSHIP_ONBOARDING_KEY = "sponsorship_onboarding_completed";
export const SPONSORSHIP_ONBOARDING_TOTAL_STEPS = 3;

export type SponsorshipOnboardingStep = 1 | 2 | 3;

const clampStep = (value: number): SponsorshipOnboardingStep => {
  if (value <= 1) return 1;
  if (value >= SPONSORSHIP_ONBOARDING_TOTAL_STEPS) return 3;
  return value as SponsorshipOnboardingStep;
};

const readCompletedFromStorage = (): boolean => {
  try {
    return storageService.getItem(SPONSORSHIP_ONBOARDING_KEY) === "true";
  }
  catch {
    return false;
  }
};

const persistCompletion = (): void => {
  try {
    storageService.setItem(SPONSORSHIP_ONBOARDING_KEY, "true");
  }
  catch {
    // ignore storage errors, still close the wizard
  }
};

// Wizard de bienvenue 3 étapes (clone de la mécanique pronostics, sans
// opt-out). Un bénéficiaire qui a déjà des recommandations n'est pas un
// nouveau venu : on pré-marque « vu » silencieusement.
export const useSponsorshipOnboarding = (hasRecommendations: boolean) => {
  const [shouldShow, setShouldShow] = useState<boolean>(() => {
    if (readCompletedFromStorage()) return false;
    if (hasRecommendations) {
      persistCompletion();
      return false;
    }
    return true;
  });
  const [currentStep, setCurrentStep] = useState<SponsorshipOnboardingStep>(1);

  const next = () => setCurrentStep((step) => clampStep(step + 1));
  const prev = () => setCurrentStep((step) => clampStep(step - 1));

  const complete = (): void => {
    persistCompletion();
    setShouldShow(false);
  };

  return {
    shouldShow,
    currentStep,
    totalSteps: SPONSORSHIP_ONBOARDING_TOTAL_STEPS,
    next,
    prev,
    complete,
  };
};
